import { useSuspenseQuery } from "@tanstack/react-query";
import { memoize } from "lodash";

import { BookableDetail } from "@/types/bookable";

import { bookableQueryOptions } from "@/api/provider/admin/bookable-query";

const transformBookables = memoize((data: BookableDetail[] | null) => {
  // very nice this only runs when data changes, across all components that use this hook
  return {
    bookables: data ?? [],
    bookableMap: new Map(data?.map((bookable) => [bookable.id, bookable])),
  };
});

export const useBookables = () => {
  const { data: bookables } = useSuspenseQuery({
    ...bookableQueryOptions.list(),
    select: transformBookables,
  });

  return bookables;
};
